export const DEFAULT_CATEGORY = 'table-planners';
